import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { discountCategoryQueries } from '@/services/discount-management/discount-category.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetDiscountCategories = () => {
  const search = useSearch({ from: '/(app)/configuration-management/discount-management/' });
  const { page, fetch, sort, q } = search;

  const { data, isLoading } = useQuery({
    ...discountCategoryQueries.list({
      row: page ?? 0,
      fetch: fetch ?? 10,
      search: q ?? '',
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return {
    data: data?.data ?? [],
    isLoading,
    pagination: data?.meta.pagination ?? defaultMeta,
  };
};
